class ElasticService {
    constructor(baseUrl, engineName, searchKey) {
        this.baseUrl = baseUrl;
        this.engineName = engineName;
        this.searchKey = searchKey;
    }
    async getAllProducts(search) {
        try {
            const params = Object.assign({
                "query": {
                    "name": {
                        "case_insensitive": true
                    },
                    "description": {
                        "case_insensitive": true
                    }
                }
            }, search);
            return await this.Query("POST", "search", params);
        }
        catch (err) {
            throw new Error(err);
        }
    }
    async getAllCategories() {
        const params = {
            query: "",
            page: {
                size: 1,
                current: 1,
            },
            facets: {
                category1: { type: "value", size: 100 },
                category2: { type: "value", size: 100 },
            },
        };
        try {
            const response = await this.Query("POST", "search", params);
            console.log("response", response);
            if (response.facets) {
                return response.facets;
            }
        }
        catch (err) {
            throw new Error(err);
        }
    }
    async getSubCategories(category) {
        const params = {
            query: "",
            filters: {
                "category1": [category]
            },
            page: {
                size: 1,
                current: 1,
            },
            facets: {
                category2: { type: "value", size: 100 }
            },
        };
        try {
            const response = await this.Query("POST", "search", params);
            console.log("response", response);
            if (response.facets) {
                return response.facets;
            }
        }
        catch (err) {
            throw new Error(err);
        }
    }
    async getProductById(product) {
        const params = {
            query: product,
            page: {
                size: 1,
                current: 1,
            },
            search_fields: {
                id: {},
            },
        };
        const response = await this.Query("POST", "search", params);
        return response;
    }
    async Query(method, url_param, params) {
        const initialUrl = `${this.baseUrl}/${this.engineName}`;
        const urlComplete = `${initialUrl}/${url_param}`;
        const body = params;
        const fetch_params = {
            method: method,
            headers: new Headers({
                Authorization: `Bearer ${this.searchKey}`,
                "Content-Type": "application/json",
            }),
            body: JSON.stringify(body),
        };
        const query = await fetch(urlComplete, fetch_params);
        return await query.json();
    }
}

const gnxCatalogue_en = () => ({
  "catalogue.title": "Catalogue",
  "catalogue.subtitle": "This is a web component",
  "catalogue.searchbar.placeholder": "Search",
  "catalogue.detail.button.redemption": "Redemption",
  "catalogue.detail.title": "Detail",
  "catalogue.detail.description.title": "Features",
  "catalogue.product.description": "Description",
  "catalogue.product.tagnew": "New",
  "catalogue.messages.not_found": "Not found",
  "catalogue.mesasges.error_network": "connection error",
  "catalogue.filters": "Filters",
  "catalogue.subcategories": "Select a subcategory",
  "catalogue.filters_clean": "Clean",
  "catalogue.filters.points_highest_lowest": " from highest to lowest",
  "catalogue.filters.points_lowest_highest": " from lowest to highest",
  "catalogue.externalfilters.apply": "Apply",
  "catalogue.externalfilters.orderBy": "Order by",
  "catalogue.externalfilters.filterBy": "Filter by",
  "catalogue.externalfilters.filterBy.option.price": "price",
  "catalogue.externalfilters.filterBy.option.alphabetically": "alphabetically",
  "catalogue.externalfilters.filterBy.option.cancel": "cancel",
  "catalogue.externalfilters.filterBy.option.ok": "ok",
  "catalogue.externalfilters.filterByPlaceholderText": "Select",
  "catalogue.externalfilters.pointz": "Pointz",
  "catalogue.externalfilters.new": "new",
  "catalogue.externalfilters.applyButton": "Apply",
  "catalogue.carousel.seeMore": "More",
  "catalogue.carousel.subtitle": "Gift cards, products and more",
  "catalogue.loading": "Loading products",
});

const en = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': gnxCatalogue_en
});

const gnxCatalogue_es = () => ({
  "catalogue.title": "Catálogo",
  "catalogue.subtitle": "Este es un web component",
  "catalogue.searchbar.placeholder": "Buscar",
  "catalogue.detail.button.redemption": "Canjear",
  "catalogue.detail.title": "Detalle",
  "catalogue.detail.description.title": "Características",
  "catalogue.product.description": "Descripción",
  "catalogue.product.tagnew": "Nuevo",
  "catalogue.messages.not_found": "No se encontró",
  "catalogue.mesasges.error_network": "Error de conexión",
  "catalogue.filters": "Filtros",
  "catalogue.subcategories": "Selecciona una subcategoría",
  "catalogue.subcategory": "Subcategorías",
  "catalogue.filters_clean": "Limpiar",
  "catalogue.filters.points_highest_lowest": " de mayor a menor",
  "catalogue.filters.points_lowest_highest": " de menor a mayor",
  "catalogue.externalfilters.apply": "Aplicar",
  "catalogue.externalfilters.orderBy": "Ordernar por",
  "catalogue.externalfilters.filterBy": "Filtrar por",
  "catalogue.externalfilters.filterBy.option.price": "Precio",
  "catalogue.externalfilters.filterBy.option.alphabetically": "Alfabéticamente",
  "catalogue.externalfilters.filterBy.option.cancel": "Cancelar",
  "catalogue.externalfilters.filterBy.option.ok": "OK",
  "catalogue.externalfilters.filterByPlaceholderText": "Seleccionar",
  "catalogue.externalfilters.pointz": "Pointz",
  "catalogue.externalfilters.new": "Nuevo",
  "catalogue.externalfilters.applyButton": "Aplicar",
  "catalogue.carousel.seeMore": "Ver más",
  "catalogue.carousel.subtitle": "Tarjetas de regalo, productos y más",
  "catalogue.loading": "Cargando Productos"
});

const es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': gnxCatalogue_es
});

const gnxCatalogue_fr = () => ({
  "catalogue.title": "Catagalogo",
  "catalogue.subtitle": "Este es un web component",
  "catalogue.searchbar.placeholder": "Buscar",
  "catalogue.detail.button.redemption": "Redimir",
  "catalogue.detail.description.title": "Caracteristicas",
  "catalogue.product.description": "Descripcion",
  "catalogue.product.tagnew": "Nuevo",
  "catalogue.messages.not_found": "ningun resuldato",
  "catalogue.mesasges.error_network": "Error de conexion",
  "catalogue.filters": "filtrar",
  "catalogue.filters.points_highest_lowest": " de mayor a menor",
  "catalogue.filters.points_lowest_highest": " de menor a mayor",
  "catalogue.externalfilters.apply": "Aplicar",  
  "catalogue.externalfilters.orderBy": "Ordernar por",
  "catalogue.externalfilters.filterBy": "Filtrar por",
  "catalogue.externalfilters.filterBy.option.price": "precio",
  "catalogue.externalfilters.filterBy.option.alphabetically": "Alfabeticamente",
  "catalogue.externalfilters.filterBy.option.cancel": "cancelar",
  "catalogue.externalfilters.filterBy.option.ok": "ok",
  "catalogue.externalfilters.filterByPlaceholderText": "Seleccione una opcion",
  "catalogue.externalfilters.pointz": "Pointz",
  "catalogue.externalfilters.new": "Nuevos",
  "catalogue.externalfilters.applyButton": "Aplicar",
  "catalogue.carousel.seeMore": "Ver más",
  "catalogue.carousel.subtitle": "Bonos, productos y experiencias",
});

const fr = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': gnxCatalogue_fr
});

function fetchLocaleStrings(locale) {
  return new Promise((resolve, reject) => {
    resolve(selectLanguaje(locale).default());
  });
}

function selectLanguaje(locale) {
  switch (locale) {
    case "es":
      return es;
    case "fr":
      return fr;
    case "en":
      return en;
  }
}

export { ElasticService as E, fetchLocaleStrings as f };
